import { Account } from '../admin/accounts/account.model';

/**
 * Describes a User object
 */
export class User {
    id: number;
    firstName: string = String();
    lastName: string = String();
    password: string = String();
    emailAddress: string = String();
    role: string;
    token: string;
    organisationName: string;
    marketingConsent: boolean;
    accounts: Array<Account>;
}

/**
 * Describes a list of Users
 */
export class UserList {
    users: Array<User>;
}

/**
 * Describes a Activation Request object
 */
export class ActivationRequest {
  token: string;
  email: string;
}

/**
 * Describes a User Account object
 */
export class UserAccount {
  mapServices: Array<UserAccountService> = [];
  tokens: Array<string> = [];
  usernames: Array<string> = [];
}

/**
 * Describes a User Account Service
 */
export class UserAccountService {
  serviceName: string;
  protocol: string;
  serviceEndpoint: string;
  serviceURLSlug: string;
}

/**
 * Describes a Password Reset Request
 */
export class PasswordResetRequest {
  email: string;
  token: string;
  newPassword: string;
}